import { FC, ReactNode } from "react";
import { useLanguageInternal } from "./useLanguageInternal";
import { useI18nLanguageSync } from "./useI18nLanguageSync";

export interface LanguageProviderProps {
  defaultLanguage: string;
  children: (language: string) => ReactNode;
}

/**
 * Reads and persists the user-facing locale in the user setting `"language"`
 * and delegates the i18next + Luxon side effects to
 * {@link useI18nLanguageSync}.
 *
 * @see useI18nLanguageSync
 * @see `docs/prd/2026/05/22/prd-i18n-language-mapping.md`
 */
export const LanguageUserSettingProvider: FC<LanguageProviderProps> = (
  props
) => {
  const { language } = useLanguageInternal(props.defaultLanguage);
  useI18nLanguageSync(language);
  return props.children(language);
};
